import { useEffect, useRef, useState } from 'react';

import * as Sentry from '@sentry/react';

/**
 * Attaches a DOM element as a Sentry User Feedback trigger.
 * Returns whether the feedback integration is available (null while checking).
 */
export const useSentryFeedback = <T extends HTMLElement>() => {
    const elementRef = useRef<T>(null);
    const [isAvailable, setIsAvailable] = useState<boolean | null>(null);

    useEffect(() => {
        const feedback = Sentry.getFeedback();
        if (!feedback) {
            setIsAvailable(false);
            return undefined;
        }

        setIsAvailable(true);

        if (!elementRef.current) {
            return undefined;
        }

        return feedback.attachTo(elementRef.current);
    }, []);

    return { elementRef, isAvailable };
};
